import React from 'react';
import Layout from '../components/Layout';
import WarehouseList from '../components/WarehouseList';

/**
 * Página de listado de tipos de camiones
 * Utiliza el componente Layout para mantener la estructura consistente
 * y el componente TruckTypeList para mostrar la lista de tipos de camiones
 */
const Warehouse = () => {
  return (
    <Layout>
      <div>
        <WarehouseList />
      </div>
    </Layout>
  );
};

export default Warehouse;
